export const BOOLVALUE = [
    { Name: "Nej", Value: "0" },
    { Name: "Ja", Value: "1" },
    { Name: "Ej valt", Value: "-1" },
  ];